<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="设备名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入设备名称" allow-clear/>
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
              <a-form-item label="设备编号" prop="number">
                <a-input v-model="queryParam.number" placeholder="请输入设备编号" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="心电图 0-不显示 1-显示" prop="electrocardiogram">-->
<!--                  <a-input v-model="queryParam.electrocardiogram" placeholder="请输入心电图 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="睡眠 0-不显示 1-显示" prop="sleep">-->
<!--                  <a-input v-model="queryParam.sleep" placeholder="请输入睡眠 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="心率 0-不显示 1-显示" prop="heartRate">-->
<!--                  <a-input v-model="queryParam.heartRate" placeholder="请输入心率 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="血压 0-不显示 1-显示" prop="bloodPressure">-->
<!--                  <a-input v-model="queryParam.bloodPressure" placeholder="请输入血压 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="血糖 0-不显示 1-显示" prop="bloodSugar">-->
<!--                  <a-input v-model="queryParam.bloodSugar" placeholder="请输入血糖 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="血氧 0-不显示 1-显示" prop="bloodOxygen">-->
<!--                  <a-input v-model="queryParam.bloodOxygen" placeholder="请输入血氧 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="呼吸率 0-不显示 1-显示" prop="respiratoryRate">-->
<!--                  <a-input v-model="queryParam.respiratoryRate" placeholder="请输入呼吸率 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="温度 0-不显示 1-显示" prop="temperature">-->
<!--                  <a-input v-model="queryParam.temperature" placeholder="请输入温度 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="血脂 0-不显示 1-显示" prop="bloodFat">-->
<!--                  <a-input v-model="queryParam.bloodFat" placeholder="请输入血脂 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="尿酸 0-不显示 1-显示" prop="uricAcid">-->
<!--                  <a-input v-model="queryParam.uricAcid" placeholder="请输入尿酸 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="生理周期 0-不显示 1-显示" prop="physiologicalCycle">-->
<!--                  <a-input v-model="queryParam.physiologicalCycle" placeholder="请输入生理周期 0-不显示 1-显示" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['device:version:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['device:version:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['device:version:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['device:version:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 350px)'}"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
             {{(current-1)*size+index+1}}
       </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="picture" slot-scope="text, record">
    <img  v-viewer style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;" v-if="record.picture"
          :src="record.picture" preview="设备图片"/>
      </span>


        <span slot="operation" slot-scope="text, record, index">
          <a-divider type="vertical" v-hasPermi="['device:version:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['device:version:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['device:version:remove']" />
          <a @click="handleDelete(record, index)" v-hasPermi="['device:version:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageVersion,listVersion, delVersion } from '@/api/device/version'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Version',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
       //索引indexs
       indexs: [], 
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        name: null,
        picture: null,
        number: null,
        electrocardiogram: null,
        sleep: null,
        heartRate: null,
        bloodPressure: null,
        bloodSugar: null,
        bloodOxygen: null,
        respiratoryRate: null,
        temperature: null,
        bloodFat: null,
        uricAcid: null,
        physiologicalCycle: null,
        label: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '主键ID',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
         {
                  title: '序号',
                  dataIndex: 'index',
                  key: 'index',
                  width: 50,
                  fixed: 'left',
                  scopedSlots: { customRender: 'index' },
        },
        // {
        //   title: '设备名称',
        //   dataIndex: 'name',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '编号',
          dataIndex: 'number',
          ellipsis: true,
          align: 'center',
          width: 120,
        },
        {
          title: '图片',
          dataIndex: 'picture',
          ellipsis: true,
       
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          title: '心电图 ',
          dataIndex: 'electrocardiogram',
          ellipsis: true,
          align: 'center',
          width:120,
      
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '睡眠 ',
          dataIndex: 'sleep',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '心率 ',
          dataIndex: 'heartRate',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '血压 ',
          dataIndex: 'bloodPressure',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '血糖 ',
          dataIndex: 'bloodSugar',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '血氧 ',
          dataIndex: 'bloodOxygen',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '呼吸率 ',
          dataIndex: 'respiratoryRate',
          ellipsis: true,
          align: 'center',
          width:120,
        
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '温度 ',
          dataIndex: 'temperature',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '血脂 ',
          dataIndex: 'bloodFat',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '尿酸 ',
          dataIndex: 'uricAcid',
          ellipsis: true,
          align: 'center',
          
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        {
          title: '生理周期 ',
          dataIndex: 'physiologicalCycle',
          ellipsis: true,
          align: 'center',
          width:120,
          customRender:function (text) {
            if (text == 0) {
              return "不显示";
            }else {
              return "显示"
            }
          }
        },
        // {
        //   title: '运动标签',
        //   dataIndex: 'label',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'operation' },
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询手设备版本列表 */
    getList () {
      this.loading = true
     pageVersion(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        picture: undefined,
        number: undefined,
        electrocardiogram: undefined,
        sleep: undefined,
        heartRate: undefined,
        bloodPressure: undefined,
        bloodSugar: undefined,
        bloodOxygen: undefined,
        respiratoryRate: undefined,
        temperature: undefined,
        bloodFat: undefined,
        uricAcid: undefined,
        physiologicalCycle: undefined,
        label: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
       // 列表顶部删除indexs
       if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row, index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1   
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delVersion(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('device/version/export', {
            ...that.queryParam
          }, `手设备版本_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
